module.exports = __webpack_public_path__ + "img/020-A.ba137058.png";